import getMessage from "../getMessage";
/**
 * @description: A helper to resolve either a language key or an already translated string.
 * Useful for resolving defaultProps
 */
export default (function (component, key, object, values) {
    if (object === void 0) { object = component.props; }
    if (values === void 0) { values = {}; }
    var formatMessage = component.props.formatMessage;
    return getMessage(formatMessage, object[key], values);
});
